module.exports = __webpack_public_path__ + "img/p38.4323f985.svg";